import { InjectionToken, TemplateRef } from '@angular/core';

import { FeatureGuidePosition } from './feature-guide-position';

export interface FeatureGuideTooltip {
  id: string;
  title: string;
  template: TemplateRef<any>;
  position: FeatureGuidePosition;
}

export const FeatureGuideTooltipToken = new InjectionToken<FeatureGuideTooltip>('@pcs/featureGuideTooltipToken');
